import {Injectable} from '@angular/core';
import {REF_MODEL_STORE, RefModelStoreService} from '@q9elements/ui-kit/common';

@Injectable({
  providedIn: 'root'
})
export class ManageCurrentSfProcessService {
  /**
   * SERVICE FOR CONTROL CURRENT SF PROCESS
   * * REFMODEL SYNC
   * * FIELD IMPACT FOR REFMODEL
   * * DATAINTEGRATION FOR WHOLE REFMODEL (EXCEPT MP)
   * * DATA POPULATION FETCHING ON ONE OF MP
   * */
  constructor(private rmeStore: RefModelStoreService) {}

  /** If current process is running */
  sfProcessStart(type: string) {
    this.rmeStore.set(REF_MODEL_STORE.CURRENT_SF_PROCESS, {type});
  }

  sfProcessStop(type: string) {
    const currentSFProcess = this.rmeStore.currentSFProcess;
    if (!currentSFProcess || currentSFProcess?.type !== type) {
      return;
    }
    this.rmeStore.set(REF_MODEL_STORE.CURRENT_SF_PROCESS, undefined);
  }

  isSomeSFProcessRunning() {
    const currentSFProcess = this.rmeStore.currentSFProcess;
    return !!currentSFProcess;
  }
}
